/**
 * @generated SignedSource<<99f4e0a1a98451ea3a6d8bd434514f11>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type templateDetailsSectionRelayFragment$data = {
  readonly name: string | null | undefined;
  readonly pluginModuleKey: string;
  readonly templateType: ReadonlyArray<{
    readonly id: string;
    readonly templateTypeName: string | null | undefined;
  }> | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"templateDescriptionRelayFragment" | "templatePreviewRelayFragment" | "templateRelatedTemplatesRelayFragment" | "templateTabbedSectionRelayFragment">;
  readonly " $fragmentType": "templateDetailsSectionRelayFragment";
};
export type templateDetailsSectionRelayFragment$key = {
  readonly " $data"?: templateDetailsSectionRelayFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"templateDetailsSectionRelayFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "templateDetailsSectionRelayFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "pluginModuleKey",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ContentPlatformTaxonomyTemplateType",
      "kind": "LinkedField",
      "name": "templateType",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "templateTypeName",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "templatePreviewRelayFragment"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "templateDescriptionRelayFragment"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "templateTabbedSectionRelayFragment"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "templateRelatedTemplatesRelayFragment"
    }
  ],
  "type": "ContentPlatformTemplate",
  "abstractKey": null
};

(node as any).hash = "a0cb459558a181e542607278d1c27860";

export default node;
